import type { User } from '@/model/user.ts'
import { defineStore } from 'pinia'
import { authRepository } from '@/api/repository/auth.repository.ts'

export const useAuthStore = defineStore('auth', {

  state: () => ({
    authenticated: false,
    sessionToken: localStorage.getItem('user_session'),
    user: JSON.parse(localStorage.getItem('user_data') || 'null'),
  }),

  getters: {
    getDisplayName: state => state.user.name,
    getUserId: (state): string => state.user?.id || '',
    getUserEmail: (state): string => state.user?.email || '',
    isAdmin: state => state.user?.isAdmin || false,
    isAuthenticated: state => state.authenticated,
  },

  actions: {
    async retrieveUser () {
      console.log('retrieving user data...')
      try {
        const user = await authRepository.me()
        if (user) {
          this.user = user
          this.authenticated = true
        }
      } catch (error) {
        this.authenticated = false
        console.error('Failed to retrieve user data:', error)
      }
    },
    login (token: string, userData: User) {
      console.log('login...', userData)
      this.sessionToken = token
      this.user = userData
      this.authenticated = true

      localStorage.setItem('user_session', token)
      localStorage.setItem('user_data', JSON.stringify(userData))
    },
  },

})
